
import { Utils } from '../lib/utils.js';

export const initDeviceSelection = () => {

	let hidden_devices = [];
	let new_hidden_devices = [];

	const views = {
		match: {
			key: 'match',
			container: '#match-devices',
			tab: '#matches',
			edit: '#show-hide',
			ok: '#show-hide-ok',
			cancel: '#show-hide-cancel',
		},
		touch: {
			key: 'touch',
			container: '#touch-devices',
			tab: '#touches',
			edit: '#touch-show-hide',
			ok: '#touch-show-hide-ok',
			cancel: '#touch-show-hide-cancel',
		},
	};

	function getAvailableViews() {
		return Object.values(views).filter((view) => (
			document.querySelector(view.container) && document.querySelector(view.tab)
		));
	}

	function getViewInputs(view) {
		return Array.from(document.querySelectorAll(`${view.container} input.show-hide`));
	}

	function getDefaultView() {
		const wrapper = document.querySelector('[data-default-view]');
		const preferred = wrapper ? wrapper.getAttribute('data-default-view') : null;
		if (preferred && views[preferred] && document.querySelector(views[preferred].container)) {
			return preferred;
		}

		const matchCount = parseInt(document.querySelector('#matches')?.getAttribute('data-count') || '0', 10);
		const touchCount = parseInt(document.querySelector('#touches')?.getAttribute('data-count') || '0', 10);
		if (touchCount > 0 && matchCount === 0 && document.querySelector(views.touch.container)) {
			return 'touch';
		}

		return 'match';
	}

	function setDeviceVisibility(uid, visible) {
		const wrapper = document.getElementById(`device-entry-${uid}`);
		if (wrapper) {
			wrapper.style.display = visible ? '' : 'none';
			return;
		}

		const button = document.getElementById(`button-${uid}`);
		if (button) {
			button.style.display = visible ? 'inline-block' : 'none';
			if (button.nextElementSibling) {
				button.nextElementSibling.style.display = visible ? 'inline-block' : 'none';
			}
		}
	}

	function setEditMode(view, editing) {
		const inputs = getViewInputs(view);
		if (!inputs.length) {
			return;
		}

		const editButton = document.querySelector(view.edit);
		const okButton = document.querySelector(view.ok);
		const cancelButton = document.querySelector(view.cancel);
		if (editButton) {
			editButton.style.display = editing ? 'none' : 'inline-block';
		}
		if (okButton) {
			okButton.style.display = editing ? 'inline-block' : 'none';
		}
		if (cancelButton) {
			cancelButton.style.display = editing ? 'inline-block' : 'none';
		}

		for (const input of inputs) {
			input.style.display = editing ? 'inline-block' : 'none';
		}

		for (const uid of hidden_devices) {
			setDeviceVisibility(uid, editing);
		}
	}

	function show(viewKey) {
		const availableViews = getAvailableViews();
		if (!views[viewKey]) {
			return;
		}

		for (const view of availableViews) {
			const visible = view.key === viewKey;
			$(view.container).css('display', visible ? 'block' : 'none');
			$(view.tab).toggleClass('active', visible);
		}
	}

	function toggleDevice(uid, remove) {
		uid = uid.substring(uid.indexOf("-") + 1);
		if (remove) {
			if (new_hidden_devices.indexOf(uid) === -1) {
				new_hidden_devices.push(uid);
			}
		} else {
			const index = new_hidden_devices.indexOf(uid);
			if (index > -1) {
				new_hidden_devices.splice(index, 1);
			}
		}
	}

	function sendSettings() {
		hidden_devices = new_hidden_devices.slice();
		$.ajax({
			url: "/solo/put/user_settings",
			type: "post",
			data: { devices: hidden_devices.join() },
			dataType: "json",
			error: function () {
				alert("Error saving change to server!");
			},
		});
	}

	function cancelSettings() {
		new_hidden_devices = hidden_devices.slice();
		$('input').prop('checked', true);
		for (var j = 0; j < hidden_devices.length; j++) {
			var checkboxElementId = "checkbox-" + hidden_devices[j];
			if (document.getElementById(checkboxElementId)) {
				document.getElementById(checkboxElementId).checked = false;
			}
		}
	}

	function toggleShowHide(viewKey) {
		const view = views[viewKey];
		if (!view) {
			return;
		}

		const isEditing = getViewInputs(view).some((input) => window.getComputedStyle(input).display !== 'none');
		setEditMode(view, !isEditing);
	}

	$.ajax({
		url: "/api/hidden_devices",
		type: "get",
		dataType: "json",
	})
		.then(function (rsp) {

			hidden_devices = rsp.slice();
			new_hidden_devices = rsp.slice();

			for (let j = 0; j < hidden_devices.length; j++) {
				const checkboxElementId = "checkbox-" + hidden_devices[j];
				if (document.getElementById(checkboxElementId)){
					setDeviceVisibility(hidden_devices[j], false);
					document.getElementById(checkboxElementId).checked = false;
				}
			}

			$("#matches").on("click", function () { show("match"); });
			$("#touches").on("click", function () { show("touch"); });
			$("[data-show-view]").on("click", function () {
				show($(this).data("show-view"));
			});
			$(".show-hide").on("click", function () { toggleDevice(this.id, !this.checked); });

			$("#show-hide").on("click", function () { toggleShowHide("match"); });
			$("#show-hide-ok").on("click", function () {
				sendSettings();
				toggleShowHide("match");
			});
			$("#show-hide-cancel").on("click", function () {
				cancelSettings();
				toggleShowHide("match");
			});

			$("#touch-show-hide").on("click", function () { toggleShowHide("touch"); });
			$("#touch-show-hide-ok").on("click", function () {
				sendSettings();
				toggleShowHide("touch");
			});
			$("#touch-show-hide-cancel").on("click", function () {
				cancelSettings();
				toggleShowHide("touch");
			});

			show(getDefaultView());
			$(".init-container").hide();
			$(".devices-container").show();

		})
		.catch(function (rsp) {
			rsp = Utils.processError(rsp);

			$(".init-container").hide();
			$(".error-content textarea").val(rsp.detail);
			$(".error-container").show();
		});

};
